module.exports = __webpack_public_path__ + "img/pelleter-2.42bc91ec.png";